/** 자동이체 은행명 선택 목록. 코드 변환표와 같은 이름만 둔다. */
const TRANSFER_BANK_NAMES = [
  '산업',
  '기업',
  '국민',
  '외환(X)',
  '수협',
  '농협',
  '지역농협',
  '우리',
  'SC제일',
  '씨티',
  'iM뱅크',
  '부산',
  '광주',
  '제주',
  '전북',
  '경남',
  '새마을금고',
  '신용협동조합',
  '상호저축은행',
  '삼성저축은행',
  'HSBC',
  '도이치',
  '우체국',
  '하나',
  '신한',
  '현대CMA',
  '산림조합',
  '카카오뱅크',
  '중국공상',
  '중국',
  'BNP파리바',
  'JP모간',
  '케이뱅크',
  '토스뱅크',
  'BOA',
  '기타금융기관',
];

export default TRANSFER_BANK_NAMES;
